import { setCookieData, useIsomorphicLayoutEffect } from '@repo/common-utils';
import { atom, useAtom } from 'jotai';

import { BZNAV_UTM_KEY } from '../constants';
import { UtmData } from '../types';
import { getClientUtm } from '../utils/platform-detector-client';

export const utmAtom = atom<UtmData>();

export const useUTM = () => {
  const [utmData, setUtmData] = useAtom(utmAtom);

  const updateUTM = (clientUtmData: UtmData) => {
    setUtmData(clientUtmData);
    sessionStorage.setItem(BZNAV_UTM_KEY, JSON.stringify(clientUtmData));

    setCookieData(BZNAV_UTM_KEY, clientUtmData);
  };

  useIsomorphicLayoutEffect(() => {
    const clientUtm = getClientUtm();
    if (!utmData || (utmData.utmSource === 'referer' && clientUtm.utmSource !== 'referer')) {
      updateUTM(clientUtm);
    }
  }, [utmData]);

  return { utmData, updateUTM };
};
